// extracted by mini-css-extract-plugin
export default {"workContainer":"styles_workContainer__AdrtF"};